import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/posh-sidekick-and-reseller-assistant';

export default function Example() {
  return (
    <>
      <Head>
        <title>Reseller Assistant, Posh Sidekick, and Poshmark Pro Tools owned by same person?</title>
        <meta name='description' content='Why do their business registration filing details look so similar?' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/posh-sidekick-and-reseller-assistant' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/posh-sidekick-and-reseller-assistant' />
        <meta
          property='og:title'
          content='Reseller Assistant, Posh Sidekick, and Poshmark Pro Tools owned by same person?'
        />
        <meta property='og:description' content='Why do their business registration filing details look so similar?' />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-10-17T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-10-17T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
